/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import { FormControlLabel, withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import queryString from 'query-string';

import { showToast } from 'modules/layout/layout.actions';
import AdvancedSearch from 'modules/common/advancedSearch.component';
// import Hint from 'modules/common/hint.component';
import Spinner from 'modules/common/spinner.component';

import {
  deleteEquity,
  getAllAppraisals,
  getAllListings,
  postAppraisal,
  postEquity,
  postHomesaleInfo,
  postListing,
  updateEquity,
  updateHomesaleInfo,
  getSpreadSelection,
  getBuyout,
  resetHomesaleStatus,
  getHomesaleInfo
} from 'modules/authorizations/store/actions/homesale.actions';

import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';

import {
  DELETE_EQUITY_FAILURE,
  GET_APPRAISALS_FAILURE,
  POST_APPRAISALS_FAILURE,
  POST_EQUITY_FAILURE,
  POST_LISTINGS_FAILURE,
  UPDATE_EQUITY_FAILURE,
  UPDATE_HOMESALE_INFO_FAILURE,
  GET_SPREAD_SELECTION_FAILURE,
  GET_BUYOUT_FAILURE
} from 'modules/authorizations/store/types/homesaleTypes';

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';

import AppraisalBmaDetails from './appraisalBmaDetails.component';
import BuyoutComponent from './buyout/buyout.component';
import Equity from './equity/equity.component';
import HsPrimaryInfo from './hsPrimaryInfo.component';
import InspectionsComponent from './inspections/inspections.component';
import Listings from './listings/listings.component';
import ResaleOffers from './resaleOffers.component';
import { CreateVendorRelationshipList } from 'modules/authorizations/utils';
import { POST_HHG_RESET_STATUS_FAILURE } from 'modules/authorizations/store/types/houseHoldGoodsTypes';
import ServiceTriggeredComment from '../commentsAndNotes/serviceTriggeredComment.component';
import SlidingCommentsAndNotes from '../commentsAndNotes/commentsAndNotesSlidingPanel.component';
import StatusMenu from 'modules/common/statusMenu.component';
import { getServiceStatusDates } from 'modules/authorizations/store/actions/authorizations.actions';
import { EMAIL_TEMPLATE_STATUS_IDS, SERVICE_IDS } from 'modules/enumerations/enumerationIds';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: {
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`
  },
  headerFixed: {
    zIndex: 4
  },
  tabFixed: {
    paddingTop: '100px',
    zIndex: 3
  },
  estimateHeaderFixed: {
    paddingTop: '150px',
    zIndex: 2
  }
});

const validTabs = ['PRIMARY', 'APPRAISALS', 'BMAs', 'LISTINGS', 'BUYOUT', 'RESALE', 'EQUITY', 'INSPECTIONS'];

const BMA_APPRAISAL_TYPE_ID = '1ab09957-1ae8-4463-aba7-8ac96cc0b427';
const ORIGINAL_LISTING_TYPE_TITLE = 'Origlist';

const isValidQueryStringTab = tab => validTabs.includes(tab);

const getDefaultTab = location => {
  const tabFromQuery = queryString.parse(location.search)?.tab ?? 'PRIMARY';
  return isValidQueryStringTab(tabFromQuery) ? tabFromQuery : 'PRIMARY';
};

const HomesaleService = props => {
  const {
    // brokerAgents,
    details,
    id,
    location,
    shouldShowSideDrawer,
    vendors,
    inspectors,
    titleReps,
    isReadOnly,
    enumerations,
    emailTemplates,
    clientInfo
  } = props;

  const [statuses, setStatuses] = useState(
    details?.serviceStatusDates ? details.serviceStatusDates.filter(s => s.serviceType === 'Homesale') : []
  );

  console.log(details.homesale);
  const [currentTab, setCurrentTab] = useState(getDefaultTab(location));
  const [appraisalId, setAppraisalId] = useState(null);
  const [appraisalsSelected, setAppraisalsSelected] = useState(getDefaultTab(location) === 'APPRAISALS');
  const [showAddAppraiser, setShowAddAppraiser] = useState(false);
  const [showAddBroker, setShowAddBroker] = useState(false);
  const [selectedAppraiser, setSelectedAppraiser] = useState(null);
  const [selectedAppraiserName, setSelectedAppraiserName] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [selectedBrokerName, setSelectedBrokerName] = useState(null);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isOrderingList, setIsOrderingList] = useState(false);
  const [listingId, setListingId] = useState(
    details.homesale && details.homesale.listings && details.homesale.listings[0] ? details.homesale.listings[0].homesaleListingId : null
  );
  const [showAddListing, setShowAddListing] = useState(false);
  const [listingType, setListingType] = useState(null);
  const [useBmaBroker, setUseBmaBroker] = useState(false);
  const [showAddEquity, setShowAddEquity] = useState(false);
  const [equityStatus, setEquityStatus] = useState(null);
  const [equityRecordType, setEquityRecordType] = useState('S');
  const [equitySaleType, setEquitySaleType] = useState(details?.homesale?.homesaleInfo ? details.homesale.homesaleInfo.saleTypeId : null);
  const [equityId, setEquityId] = useState(null);
  const [showPostVoucher, setShowPostVoucher] = useState(null);
  const [batchType, setBatchType] = useState(null);
  const [notPayabale, setNotPayable] = useState(null);
  const [createAsRushPayment, setCreateAsRushPayment] = useState(null);
  const [createAsWireTransfer, setCreateAsWireTransfer] = useState(null);
  const [proceedsVendorId, setProceedsVendorId] = useState(null);
  const [proceedsVendorName, setProceedsVendorName] = useState(null);
  const [showTriggeredComment, setShowTriggeredComment] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [homesaleStatus, setHomesaleStatus] = useState(
    details?.homesale?.homesaleInfo ? details.homesale.homesaleInfo.homesaleStatusId : null
  );
  const [openStatusMenu, setOpenStatusMenu] = useState(false);
  const homesaleStatusId = details?.homesale?.homesaleInfo?.homesaleStatusId;
  const getServiceStatusDates = props.getServiceStatusDates;
  const homesaleBuyout = details.homesale?.homesaleBuyout;
  const { getAllAppraisals, getBuyout, getSpreadSelection, showToast } = props;

  useEffect(() => {
    let isActive = true;
    const loadStatuses = async () => {
      const response = await getServiceStatusDates(id);
      if (isActive && Array.isArray(response?.response)) {
        setStatuses(response.response.filter(s => s.serviceType === 'Homesale'));
      }
    };

    if (id) loadStatuses();
    return () => {
      isActive = false;
    };
  }, [id, homesaleStatusId, getServiceStatusDates]);

  const vendorsPreferredVendorSorted = CreateVendorRelationshipList(vendors, clientInfo?.clientDetails.clientVendorRelationships);
  const clientId = clientInfo?.clientDetails?.clientDetails?.clientRecordId;
  const banks = details.bankAccounts;
  const authFileNumber = details.authorizationDetails?.fileNumber;

  const homesaleId = details && details.homesale && details.homesale.homesaleInfo ? details.homesale.homesaleInfo.homesaleId : null;

  useEffect(() => {
    if (!homesaleId) return;

    const loadHomesaleDetails = async () => {
      const appraisalResult = await getAllAppraisals(homesaleId);
      if (appraisalResult.type === GET_APPRAISALS_FAILURE) {
        showToast('Failed to get the homesale appraisals info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }

      const spreadSelection = await getSpreadSelection(homesaleId);
      if (spreadSelection.type === GET_SPREAD_SELECTION_FAILURE) {
        showToast('Failed to get the homesale spread selection info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }

      if (!homesaleBuyout) {
        const buyoutResult = await getBuyout(homesaleId);
        if (buyoutResult.type === GET_BUYOUT_FAILURE) {
          showToast('Failed to get the homesale buyout info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }
    };

    loadHomesaleDetails();
  }, [homesaleBuyout, homesaleId, getAllAppraisals, getBuyout, getSpreadSelection, showToast]);

  useEffect(() => {
    setHomesaleStatus(details.homesale?.homesaleInfo?.homesaleStatusId);
  }, [details.homesale]);

  const inspections = details && details.homesale && details.homesale.homesaleInfo ? details.homesale.inspections : [];
  const resaleOffers = details && details.homesale && details.homesale.resaleOffers ? details.homesale.resaleOffers : [];
  const fallThrough = details && details.homesale ? details.homesale.hasFallThroughDate : false;
  //Cancel date is not null = canceled
  const isCancelled = details && details.homesale && details.homesale.homesaleInfo ? details.homesale.homesaleInfo.cancelled : false;
  const isOnHold = details && details.homesale && details.homesale.homesaleInfo ? isIdEqual(details.homesale.homesaleInfo.homesaleStatusId, 'D1B2C3A4-E5F6-4A7B-8C9D-0E1F2A3B4C5D') : false;

  // The broker currently selected on the BMAs tab, if any. Mirrors the selection logic in appraisalBmaDetails - the
  // record matching the selected appraisal id, falling back to the first BMA when the tab hasn't been visited yet.
  const bmaAppraisals = (details?.homesale?.appraisalsBmas || []).filter(a => isIdEqual(a.appraisalTypeId, BMA_APPRAISAL_TYPE_ID));
  const selectedBma = bmaAppraisals.find(a => a.homesaleAppraisalId === appraisalId) || bmaAppraisals[0] || null;
  const bmaBroker = selectedBma ? (vendors || []).find(v => v.vendorId === selectedBma.vendorId) || null : null;

  const typeOptions =
    enumerations &&
      enumerations.allEnums &&
      enumerations.allEnums.homesaleProgramTypes &&
      enumerations.allEnums.homesaleProgramTypes.length > 0
      ? enumerations.allEnums.homesaleProgramTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const listingTypes =
    enumerations && enumerations.allEnums && enumerations.allEnums.listingTypes && enumerations.allEnums.listingTypes.length > 0
      ? enumerations.allEnums.listingTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const originalListingType = listingTypes.find(type => type.title === ORIGINAL_LISTING_TYPE_TITLE) || null;

  const filteredListingTypes = () => {
    let filtered = [];
    if (listingTypes && listingTypes.length > 0) {
      if (originalListingType) {
        filtered.push(originalListingType);
      }
      listingTypes.map(type => {
        if (type.title !== ORIGINAL_LISTING_TYPE_TITLE && type.id !== '00000000-0000-0000-0000-000000000000') {
          filtered.push(type);
        }
      });
    }
    return filtered;
  };

  const isFirstListing = !details?.homesale?.listings || details.homesale.listings.length === 0;

  const openAddListingModal = () => {
    setUseBmaBroker(false);
    setSelectedBroker(null);
    setSelectedBrokerName('');
    // The very first listing on a homesale is always the original listing.
    setListingType(isFirstListing ? '9846c356-95e2-41ec-921d-338def4ef81a' : null);
    setShowAddListing(true);
  };

  const toggleUseBmaBroker = useBroker => {
    setUseBmaBroker(useBroker);
    setSelectedBroker(useBroker ? bmaBroker?.vendorId ?? null : null);
    setSelectedBrokerName(useBroker ? bmaBroker?.companyName ?? '' : '');
  };

  const equityStatuses =
    enumerations && enumerations.allEnums && enumerations.allEnums.equityStatuses && enumerations.allEnums.equityStatuses.length > 0
      ? enumerations.allEnums.equityStatuses.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const moveTypes =
    enumerations && enumerations.allEnums && enumerations.allEnums.moveTypes && enumerations.allEnums.moveTypes.length > 0
      ? enumerations.allEnums.moveTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const saleTypes =
    enumerations && enumerations.allEnums && enumerations.allEnums.saleTypes && enumerations.allEnums.saleTypes.length > 0
      ? enumerations.allEnums.saleTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentServiceTypes =
    enumerations && enumerations.allEnums && enumerations.allEnums.authCommentService && enumerations.allEnums.authCommentService.length > 0
      ? enumerations.allEnums.authCommentService.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    enumerations &&
      enumerations.allEnums &&
      enumerations.allEnums.authCommentRegarding &&
      enumerations.allEnums.authCommentRegarding.length > 0
      ? enumerations.allEnums.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const searchingColumns = [
    { name: 'vendorId', title: 'Id' },
    { name: 'companyName', title: 'Company Name' }
  ];
  const searchingColumnExtensions = [
    { columnName: 'vendorId', width: 125 },
    { columnName: 'companyName', width: 150 }
  ];

  const createBmaAndAppraisalTemplates = () => {
    if (!emailTemplates || emailTemplates.length === 0) return [];

    const appraisalTemplates = emailTemplates.filter(
      t =>
        isIdEqual(t.versionStatusId, EMAIL_TEMPLATE_STATUS_IDS.ACTIVE) &&
        isIdEqual(t.serviceId, SERVICE_IDS.HOME_SALE_SERVICE_ID) &&
        t.containsAppraisals &&
        !t.containsInspections &&
        !t.containsEquity &&
        !t.containsListings &&
        !t.containsResale
    );

    return appraisalTemplates;
  };

  const bmaAndAppraisalTemplates = createBmaAndAppraisalTemplates();

  const completeService = async () => {
    setHomesaleStatus(
      enumerations.allEnums.homesaleStatusTypes.find(s => s.status === 'Completed')?.id ?? '00000000-0000-0000-0000-000000000000'
    );
    setIsLoadingModal(true);
    let request = {
      ...details.homesale.homesaleInfo,
      homesaleStatusId:
        enumerations.allEnums.homesaleStatusTypes.find(s => s.status === 'Completed')?.id ?? '00000000-0000-0000-0000-000000000000'
    };
    const resp = await props.updateHomesaleInfo(request);
    if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
      props.showToast('Failed to complete the homesale, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      await props.getServiceStatusDates(id);
    }
    setIsLoadingModal(false);
  };

  const createAppraisal = async () => {
    setIsLoadingModal(true);

    const selectedAppraiserData = vendors.find(b => b.vendorId === selectedAppraiser);
    const resp = await props.postAppraisal(id, {
      homesaleId: details.homesale.homesaleInfo.homesaleId,
      isAgentSelected: false,
      appApplistedToTypeId: '00000000-0000-0000-0000-000000000000',
      byWhom: '',
      vendorId: selectedAppraiserData?.vendorId,
      reviewedBy: '',
      appraisalStatusId: '00000000-0000-0000-0000-000000000000',
      appraisalTypeId: '1bc0f499-6ed9-4400-b777-fc660f69b68c',
      recommendedBy: '',
      HomeForListing: '',
      contactUid: '',
      contactFirst: '',
      contactLast: '',
      orgName: '',
      notes: '',
      delayReason: '',
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date()
    });

    if (resp.type === POST_APPRAISALS_FAILURE) {
      props.showToast('Failed to create the new Appraisal, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
    } else {
      const allAppraisalsResp = await props.getAllAppraisals(details.homesale.homesaleInfo.homesaleId);
      if (allAppraisalsResp.type === GET_APPRAISALS_FAILURE) {
        props.showToast('Failed to fetch homesale appraisals, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        props.showToast('Appraiser added successfully!', { userMustDismiss: false, severity: 'success' });
        setAppraisalId(resp.response.homesaleAppraisalId);
        setShowAddAppraiser(false);
      }
      setIsLoadingModal(false);
    }
  };

  const createBma = async () => {
    setIsLoadingModal(true);

    const selectedAppraiserData = vendors.find(b => b.vendorId === selectedBroker);

    const resp = await props.postAppraisal(id, {
      homesaleId: details.homesale.homesaleInfo.homesaleId,
      isAgentSelected: false,
      appApplistedToTypeId: '00000000-0000-0000-0000-000000000000',
      byWhom: '',
      //agentId: selectedAppraiserData?.agentId,
      vendorId: selectedAppraiserData?.vendorId,
      reviewedBy: '',
      appraisalStatusId: '00000000-0000-0000-0000-000000000000',
      appraisalTypeId: '1ab09957-1ae8-4463-aba7-8ac96cc0b427',
      recommendedBy: '',
      HomeForListing: '',
      contactUid: '',
      contactFirst: '',
      contactLast: '',
      orgName: '',
      notes: '',
      delayReason: '',
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date()
    });

    if (resp.type === POST_APPRAISALS_FAILURE) {
      props.showToast('Failed to create the new BMA, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
    } else {
      const allAppraisalsResp = await props.getAllAppraisals(details.homesale.homesaleInfo.homesaleId);
      if (allAppraisalsResp.type === GET_APPRAISALS_FAILURE) {
        props.showToast('Failed to fetch homesale appraisals, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        props.showToast('BMA Added successfully!', { userMustDismiss: false, severity: 'success' });
        setAppraisalId(resp.response.homesaleAppraisalId);
        setShowAddBroker(false);
      }
      setIsLoadingModal(false);
    }
  };

  const createListing = async () => {
    setIsLoadingModal(true);

    const selectedAppraiserData = vendors.find(b => b.vendorId === selectedBroker);

    const resp = await props.postListing(
      {
        homesaleId: details.homesale.homesaleInfo.homesaleId,
        brokerId: selectedAppraiserData?.vendorId,
        hasExclusionClause: false,
        incentives: '',
        listingStatusId: '5462aeca-0424-4578-a841-0cfbc871366e',
        listingTypeId: listingType,
        listingAgentPhone: '',
        listingAgentName: '',
        mlsLink: '',
        listingAgentEmail: '',
        noReferralReason: '',
        selectedByListingTypeId: '00000000-0000-0000-0000-000000000000',
        areFeesCollected: false,
        reasonNotCollected: '',
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date()
      },
      id
    );

    if (resp.type === POST_LISTINGS_FAILURE) {
      props.showToast('Failed to create the new listing, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
    } else {
      props.showToast('Listing added successfully!', { userMustDismiss: false, severity: 'success' });
      setListingId(resp.response[resp.response.length - 1].homesaleListingId);
      setShowAddListing(false);
      setIsLoadingModal(false);
    }
  };

  const createEquity = async () => {
    setIsLoadingModal(true);

    const resp = await props.postEquity(id, {
      homesaleId: details.homesale.homesaleInfo.homesaleId,
      corpEquityExpCode: '',
      equityComments: '',
      equityStatusId: equityStatus,
      equityTypeId: '00000000-0000-0000-0000-000000000000',
      firstLender: '',
      firstMortgageExpCode: '',
      firstMortgageTypeId: '00000000-0000-0000-0000-000000000000',
      holdbackCode: '',
      holdbackDesc: '',
      prorationDaysTypeId: '00000000-0000-0000-0000-000000000000',
      saleTypeId: equitySaleType,
      secondLender: '',
      secondMortgageExpCode: '',
      secondMortgageTypeId: '00000000-0000-0000-0000-000000000000',
      thirdExpCode: '',
      thirdLender: '',
      thirdMortgageTypeId: '00000000-0000-0000-0000-000000000000',
      corpEquityAdvanceCode: '',
      addedBy: 1,
      addedOn: new Date(),
      equityRecordType: equityRecordType,
    });

    if (resp.type === POST_EQUITY_FAILURE) {
      props.showToast('Failed to create the new equity, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      props.showToast('Equity added successfully!', { userMustDismiss: false, severity: 'success' });
      setEquityId(resp.response[resp.response.length - 1].equityInfo.homesaleEquityId);
      setShowAddEquity(false);
      setIsLoadingModal(false);
    }
  };

  const cancelService = async () => {
    setHomesaleStatus(
      enumerations.allEnums.homesaleStatusTypes.find(s => s.status === 'Cancelled')?.id ?? '00000000-0000-0000-0000-000000000000'
    );
    setIsLoadingModal(true);
    let request = {
      ...details.homesale.homesaleInfo,
      cancelled: isCancelled ? null : new Date().toISOString().split('T')[0],
      homesaleStatusId:
        enumerations.allEnums.homesaleStatusTypes.find(s => s.status === 'Cancelled')?.id ?? '00000000-0000-0000-0000-000000000000'
    };
    const resp = await props.updateHomesaleInfo(request);
    if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
      props.showToast('Failed to cancel the homesale, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      await props.getServiceStatusDates(id);
    }
    setIsLoadingModal(false);
  };

  const onHoldService = async () => {
    setIsLoadingModal(true);

    //If it is already on hold, dont change the value.
    let currentStart = isOnHold ? details.homesale.homesaleInfo.onHoldStartDate : new Date().toISOString().split('T')[0];
    //If it already on hold, set the end date to today, otherwise leave it null because this will be to 'unhold' the homesale.
    let currentEnd = isOnHold ? new Date().toISOString().split('T')[0] : null;

    let request = {
      ...details.homesale.homesaleInfo,
      onHoldStartDate: currentStart,
      onHoldEndDate: currentEnd
    };

    const resp = await props.updateHomesaleInfo(request);
    if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
      props.showToast('Failed to put the homesale on hold, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      await props.getServiceStatusDates(id);
    }
    setIsLoadingModal(false);
  };

  const deleteEquityById = async equityId => {
    const resp = await props.deleteEquity(id, homesaleId, equityId);
    if (resp.type === DELETE_EQUITY_FAILURE) {
      return false;
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      setEquityId(resp.response[resp.response.length - 1] ? resp.response[resp.response.length - 1].equityInfo.homesaleEquityId : null);
      return true;
    }
  };

  const postVoucher = async () => {
    setIsLoadingModal(true);

    let newValues = details?.authHomesale?.equities.find(e => e.equityId === equityId);

    newValues.postedOn = new Date();

    const resp = await props.updateEquity(id, newValues);
    if (resp.type === UPDATE_EQUITY_FAILURE) {
      props.showToast('Failed to post voucher, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingModal(false);
      return false;
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      props.showToast('Voucher posted successfully!', { userMustDismiss: false, severity: 'success' });
      setEquityId(resp.response.equityId);
      setShowPostVoucher(false);
      setIsLoadingModal(false);
    }
  };

  const exportSampleFile = () => {
    let csvContent = 'data:text/csv;charset=utf-8,Sample,Equity,Report,Content,';

    let encodedUri = encodeURI(csvContent);
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `Sample Homesale Equity Report ${new Date().toLocaleDateString()}.csv`);
    document.body.appendChild(link); // Required for FF

    link.click();
  };

  const orderList = async () => {
    setIsOrderingList(true);
    let newValues = { ...details.homesale.homesaleInfo };
    newValues.brokerRequestListSent = true;
    const resp = await props.updateHomesaleInfo(newValues);
    if (resp.type === UPDATE_HOMESALE_INFO_FAILURE) {
      props.showToast('Failed to order broker list, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsOrderingList(false);
      return false;
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      setIsOrderingList(false);
      return true;
    }
  };

  const changeTab = tab => {
    setCurrentTab(tab);
    const values = queryString.parse(location.search);
    values.tab = tab;
    props.history.replace(`${location.pathname}?${queryString.stringify(values)}`);
    if (tab === 'APPRAISALS') {
      setAppraisalsSelected(true);
    } else {
      setAppraisalsSelected(false);
    }
  };

  const resetStatus = async () => {
    setHomesaleStatus(
      enumerations.allEnums.homesaleStatusTypes.find(s => s.status === 'Initiated')?.id ?? '00000000-0000-0000-0000-000000000000'
    );
    setIsLoadingModal(true);
    const resp = await props.resetHomesaleStatus(details.homesale.homesaleInfo.authorizationFileId);
    if (resp.type === POST_HHG_RESET_STATUS_FAILURE) {
      props.showToast('Failed to reset homesale status, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      await props.getHomesaleInfo(details.homesale.homesaleInfo.authorizationFileId);
      await props.getServiceStatusDates(details.homesale.homesaleInfo.authorizationFileId);
    }
    setIsLoadingModal(false);
  };

  const homesaleStatusOrder = [
    {
      title: 'Initiated',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Initiated')?.id
          : '',
      isActive: true,
      date: details.homesale?.homesaleInfo?.initiationDate ?? null
    },
    {
      title: 'Agent Vetting',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Agent Vetting')?.id
          : '',
      isActive: true,
      date: details.homesale?.appraisalPreferences && details.homesale?.appraisalPreferences.length > 0 ? details.homesale?.appraisalPreferences[0].brokerRequestSentOn : null
    },
    {
      title: 'BMAs Ordered',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'BMAs Ordered')?.id
          : '',
      isActive: true,
      date: details.homesale?.appraisalsBmas && details.homesale?.appraisalsBmas.length > 0 ? details.homesale?.appraisalsBmas[0].ordered : null
    },
    {
      title: 'BMAs Received',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'BMAs Received')?.id
          : '',
      isActive: true,
      date: details.homesale?.appraisalsBmas && details.homesale?.appraisalsBmas.length > 0 ? details.homesale?.appraisalsBmas.filter(bma => bma.receivedDate)[0]?.receivedDate : null
    },
    {
      title: 'Agent Selected',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Agent Selected')?.id
          : '',
      isActive: true,
      date: details.homesale?.appraisalsBmas && details.homesale?.appraisalsBmas.length > 0 ? details.homesale?.appraisalsBmas.filter(bma => bma.isAgentSelected)[0]?.agentSelectedDate : null
    },
    {
      title: 'Listing',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Listing')?.id
          : '',
      isActive: true,
      date: details.homesale?.listings && details.homesale?.listings.length > 0 ? details.homesale?.listings[0].listDate : null
    },
    {
      title: 'GBO Process Started',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'GBO Process Started')?.id
          : '',
      isActive: true,
      date: details.homesale?.appraisalsBmas && details.homesale?.appraisalsBmas.length > 0 ? details.homesale?.appraisalsBmas.filter(bma => bma.appraisalTypeId === '1bc0f499-6ed9-4400-b777-fc660f69b68c')[0]?.ordered : details.homesale?.inspections && details.homesale?.inspections.length > 0 ? details.homesale?.inspections[0].orderedDate : null
    },
    {
      title: 'Contract Pending Signatures',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Contract Pending Signatures')?.id
          : '',
      isActive: true,
      date: details.homesale?.resaleOffers && details.homesale?.resaleOffers.length > 0 ? details.homesale?.resaleOffers[0].offerDate : null
    },
    {
      title: 'Under Contract',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Under Contract')?.id
          : '',
      isActive: true,
      date: details.homesale?.resaleOffers && details.homesale?.resaleOffers.length > 0 ? details.homesale?.resaleOffers[0].resaleContractDate : null

    },
    {
      title: 'Inventory Listing',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Inventory Listing')?.id
          : '',
      isActive: true,
      date: details.homesale?.homesaleInfo ? details.homesale?.homesaleInfo.inventoryListingDate : null
    },
    {
      title: 'Inventory Under Contract',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Inventory Under Contract')?.id
          : '',
      isActive: true,
      date: details.homesale?.homesaleInfo ? details.homesale?.homesaleInfo.inventoryUnderContractDate : null
    },
    {
      title: 'Canceled',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Canceled')?.id
          : '',
      isActive: props.homesaleStatusTypes.find(hst => hst.id === homesaleStatus)?.title === 'Canceled' ? true : false,
      date: details.homesale?.homesaleInfo?.canceledDate ?? null
    },
    {
      title: 'On Hold',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'On Hold')?.id
          : '',
      isActive: props.homesaleStatusTypes.find(hst => hst.id === homesaleStatus)?.title === 'On Hold' ? true : false,
      date: details.homesale?.homesaleInfo?.onHoldDate ?? null
    },
    {
      title: 'Completed',
      id:
        enumerations && enumerations.homesaleStatusTypes && enumerations.homesaleStatusTypes.length > 0
          ? enumerations.homesaleStatusTypes.find(s => s.title === 'Completed')?.id
          : '',
      isActive: props.homesaleStatusTypes.find(hst => hst.id === homesaleStatus)?.title === 'Completed' ? true : false,
      date: details.homesale?.homesaleInfo?.completedDate ?? null
    }
  ];

  const onHoldText = isOnHold ? 'Remove On Hold' : 'Set On Hold';

  return (
    <>
      <Box>
        {showComment && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1200,
              pointerEvents: 'none'
            }}
          />
        )}
        <Paper
          square
          className={classNames({
            'position-fixed': !isReadOnly,
            [props.classes.headerFixed]: !isReadOnly,
            [props.classes.container]: true,
            [props.classes.drawerOpen]: shouldShowSideDrawer
          })}
          sx={isReadOnly ? { paddingTop: '5px', zIndex: 4, position: 'relative' } : {}}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
              <div></div>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
              <StatusMenu
                anchorEl={openStatusMenu}
                onClose={() => setOpenStatusMenu(false)}
                currentStatus={props.homesaleStatusTypes.find(hst => hst.id === homesaleStatus)?.title}
                statusHeader="Homesale Status"
                statusList={homesaleStatusOrder}
                statusDates={statuses}
                isHomesale={false}
                serviceInitiationDate={details.homesale?.homesaleInfo?.initiationDate}
              />
              <Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    Move Type
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {details.authorizationDetails.moveTypeId ? (
                      moveTypes.find(mt => mt.id === details.authorizationDetails.moveTypeId).title
                    ) : (
                      <div>&mdash;</div>
                    )}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    Policy
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {props.clientInfo && props.clientInfo.clientDetails && props.clientInfo.clientDetails.clientRelocationPolicies ? (
                      details.authorizationDetails.relocationPolicyId ? (
                        props.clientInfo.clientDetails.clientRelocationPolicies.find(
                          crp => crp.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId
                        )?.policy?.policyDescription
                      ) : (
                        <div>&mdash;</div>
                      )
                    ) : (
                      <div>&mdash;</div>
                    )}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    Sale Type
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {details.homesale.homesaleInfo ? (
                      saleTypes.find(mt => mt.id === details.homesale.homesaleInfo.saleTypeId).title
                    ) : (
                      <div>&mdash;</div>
                    )}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    MRES Id
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {details.homesale.homesaleInfo && details.homesale.homesaleInfo.morrealeHomesaleFileId ? (
                      details.homesale.homesaleInfo.morrealeHomesaleFileId
                    ) : (
                      <div>N/a</div>
                    )}
                  </Typography>
                </Box>
              </Box>
              {fallThrough && (
                <Box>
                  <Box>
                    <Box sx={{ marginBottom: '4px', marginRight: '20px', marginTop: '5px', marginLeft: '12px' }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color: fallThrough ? '#fff' : '#43423a',
                          fontWeight: 500,
                          fontSize: '1rem',
                          textAlign: 'center',
                          backgroundColor: fallThrough ? '#d32f2f' : 'transparent',
                          padding: fallThrough ? '6px 14px' : '0',
                          borderRadius: fallThrough ? '4px' : '0',
                          display: 'inline-block'
                        }}
                      >
                        {fallThrough ? 'Has Fall Through' : 'No'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
              {!isReadOnly && (
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: '#f01dc9ff',
                    '&:hover': { backgroundColor: '#ba007fff' }
                  }}
                  onClick={resetStatus}
                  disabled={isLoadingModal}
                >
                  Reset (Testing)
                </Button>
              )}
              {!isReadOnly && (
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: '#868686',
                    '&:hover': { backgroundColor: '#474747' }
                  }}
                  onClick={cancelService}
                  disabled={isLoadingModal}
                >
                  {isCancelled ? 'Open Service' : 'Cancel Service'}
                </Button>
              )}
              {!isReadOnly && (
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: '#f0b11d',
                    '&:hover': { backgroundColor: '#ba8a00' }
                  }}
                  onClick={onHoldService}
                  disabled={isLoadingModal}
                >
                  {onHoldText}
                </Button>
              )}
              {!isReadOnly && (
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                  onClick={completeService}
                  disabled={isLoadingModal}
                >
                  {' '}
                  Complete Service{' '}
                </Button>
              )}
              {!isReadOnly && (
                <Button
                  onClick={() => setShowComment(true)}
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: '#41B7C0',
                    color: 'white',
                    '&:hover': { backgroundColor: '#3d959c' }
                  }}
                  disabled={isLoadingModal}
                >
                  Comments
                </Button>
              )}
            </Box>
          </Box>
        </Paper>
        <Paper
          square
          className={classNames({
            'position-fixed': !isReadOnly,
            [props.classes.tabFixed]: !isReadOnly,
            [props.classes.container]: true,
            [props.classes.drawerOpen]: shouldShowSideDrawer
          })}
          sx={isReadOnly ? { paddingTop: '5px', zIndex: 3, position: 'relative' } : {}}
        >
          <Tabs variant="fullWidth" value={currentTab} onChange={(event, tab) => changeTab(tab)} sx={{}}>
            <Tab value={'PRIMARY'} label="Primary Info" />
            <Tab value={'BMAs'} label="BMAs" />
            <Tab value={'LISTINGS'} label="Listings" />
            <Tab value={'INSPECTIONS'} label="Inspections" />
            <Tab value={'APPRAISALS'} label="Appraisals" />
            {details.homesale.homesaleInfo.saleTypeId !== '75478d42-7d85-41b1-8447-65c2efaf0343' && <Tab value={'EQUITY'} label="Equity" />}
            {/*{details.homesale.homesaleInfo.saleTypeId !== 1 && <Tab value={'INSPECTIONS'} label="Inspections" />} */}
            <Tab value={'BUYOUT'} label="Buyout" />
            <Tab value={'RESALE'} label="Resale" />
          </Tabs>
        </Paper>
        {currentTab === 'LISTINGS' && (
          <Paper
            square
            className={classNames({
              'position-fixed': !isReadOnly,
              [props.classes.estimateHeaderFixed]: !isReadOnly,
              [props.classes.container]: true,
              [props.classes.drawerOpen]: shouldShowSideDrawer
            })}
            sx={isReadOnly ? { paddingTop: '5px', zIndex: 2, position: 'relative' } : {}}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '20px' }}>
                <Select
                  labelId={'listingId'}
                  key={'listingId'}
                  label={''}
                  name={'listingId'}
                  value={listingId}
                  sx={{ maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setListingId(e.target.value)}
                >
                  {details &&
                    details.homesale &&
                    details.homesale.listings.map(opt => (
                      <MenuItem key={opt.homesaleListingId} value={opt.homesaleListingId} sx={{ margin: 'dense' }}>
                        {(() => {
                          const broker = vendors?.find(a => a.vendorId === opt.brokerId);
                          const listingType = filteredListingTypes().find(t => t.id === opt.listingTypeId);
                          const brokerName = broker?.companyName ? broker.companyName.trim() : '';
                          const listingStatus = isIdEqual(opt.listingStatusId, '5462aeca-0424-4578-a841-0cfbc871366e');
                          return `${listingStatus ? 'Active' : 'Inactive'} - ${brokerName || 'Unknown Broker'} (${listingType?.title || ''})`;
                        })()}
                      </MenuItem>
                    ))}
                </Select>
                {!isReadOnly && (
                  <Button
                    color="secondary"
                    type="submit"
                    variant="contained"
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    onClick={openAddListingModal}
                    disabled={isLoadingModal || isReadOnly}
                  >
                    New Listing
                  </Button>
                )}
              </Box>
            </Box>
          </Paper>
        )}
        <Box
          sx={{
            padding: currentTab === 'INSPECTIONS' ? '5px' : '20px',
            paddingTop: isReadOnly ? '20px' : currentTab === 'LISTINGS' ? '245px' : currentTab === 'INSPECTIONS' ? '153px' : '165px'
          }}
        >
          {currentTab === 'PRIMARY' && (
            <HsPrimaryInfo
              details={details}
              id={id}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              emailTemplates={emailTemplates}
              vendors={vendorsPreferredVendorSorted}
              authCommentRegardingTypes={authCommentRegardingTypes}
              authCommentServiceTypes={authCommentServiceTypes}
              history={props.history}
              homesaleStatusTypes={props.homesaleStatusTypes}
              homesaleCurrentStatus={homesaleStatus}
              brokerAgents={vendors}
              isLoadingModal={isLoadingModal}
              isOnHold={isOnHold}
            />
          )}
          {(currentTab === 'APPRAISALS' || currentTab === 'BMAs') && (
            <AppraisalBmaDetails
              details={details}
              id={id}
              appraisalId={appraisalId}
              appraisalsSelected={appraisalsSelected}
              vendors={vendors}
              isReadOnly={isReadOnly || isLoadingModal}
              orderList={orderList}
              isOrderingList={isOrderingList}
              setIsOrderingList={setIsOrderingList}
              shouldShowSideDrawer={shouldShowSideDrawer}
              setAppraisalId={setAppraisalId}
              setShowAddAppraiser={setShowAddAppraiser}
              setShowAddBroker={setShowAddBroker}
              enumerations={enumerations}
              validTemplates={bmaAndAppraisalTemplates}
              sentEmailTemplates={details.sentEmailTemplates}
              history={props.history}
            />
          )}
          {currentTab === 'LISTINGS' && (
            <Listings
              details={details}
              id={id}
              listingId={listingId}
              brokerAgents={vendors}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              isLoadingModal={isLoadingModal}
            />
          )}
          {currentTab === 'BUYOUT' && (
            <BuyoutComponent
              homesale={details?.homesale?.homesaleBuyout}
              titleReps={titleReps}
              homesaleId={details?.homesale?.homesaleInfo?.homesaleId}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              vendors={vendorsPreferredVendorSorted}
              fileId={id}
              isLoadingModal={isLoadingModal}
            />
          )}
          {currentTab === 'RESALE' && (
            <h1>
              <ResaleOffers
                details={details}
                authId={id}
                brokerAgents={vendors}
                isReadOnly={isReadOnly || isLoadingModal}
                enumerations={enumerations.allEnums}
                homesaleId={homesaleId}
                resaleOffers={resaleOffers}
              />
            </h1>
          )}
          {currentTab === 'EQUITY' && (
            <Equity
              details={details}
              authId={id}
              equityId={equityId}
              isReadOnly={isReadOnly || isLoadingModal}
              enumerations={enumerations}
              setEquityId={setEquityId}
              equities={details.homesale.equities}
              equityStatuses={equityStatuses}
              setShowAddEquity={setShowAddEquity}
              deleteEquityById={deleteEquityById}
              exportSampleFile={exportSampleFile}
              setShowPostVoucher={setShowPostVoucher}
              homesaleId={homesaleId}
              authBanks={banks}
              authFileNumber={authFileNumber}
              clientId={clientId}
            />
          )}
          {currentTab === 'INSPECTIONS' && (
            <InspectionsComponent
              inspectors={inspectors}
              brokers={vendors}
              vendors={vendorsPreferredVendorSorted}
              authId={id}
              inspections={inspections}
              isReadOnly={isReadOnly || isLoadingModal}
              enumerations={enumerations.allEnums}
              homesaleId={homesaleId}
            />
          )}
        </Box>

        <Dialog open={showAddAppraiser} fullWidth={false} maxWidth={'lg'}>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box>
              <AdvancedSearch
                labelText={'Appraiser'}
                displayValueAccessorKey={'companyName'}
                saveIdValueAccessorKey={'vendorId'}
                searchingCriteria={searchingColumns}
                searchingCriteriaExtensions={searchingColumnExtensions}
                searchingRows={vendors}
                id={selectedAppraiser}
                value={selectedAppraiserName}
                setIdValue={(id, value) => {
                  setSelectedAppraiser(id);
                  setSelectedAppraiserName(value);
                }}
                isReadOnly={isReadOnly || isLoadingModal}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isLoadingModal && !isReadOnly && (
              <>
                <Button onClick={() => setShowAddAppraiser(false)}>Cancel</Button>
                <Button onClick={createAppraisal} color="primary" type="submit" variant="contained" disabled={selectedAppraiser == null || isLoadingModal || isReadOnly}>
                  Create Appraisal
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={showAddBroker} fullWidth={false} maxWidth={'lg'}>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box>
              <AdvancedSearch
                labelText={'Broker'}
                displayValueAccessorKey={'companyName'}
                saveIdValueAccessorKey={'vendorId'}
                searchingCriteria={searchingColumns}
                searchingCriteriaExtensions={searchingColumnExtensions}
                searchingRows={vendors}
                id={selectedBroker}
                value={selectedBrokerName}
                setIdValue={(id, value) => {
                  setSelectedBroker(id);
                  setSelectedBrokerName(value);
                }}
                isReadOnly={isReadOnly || isLoadingModal}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isLoadingModal && !isReadOnly && (
              <>
                <Button onClick={() => setShowAddBroker(false)}>Cancel</Button>
                <Button onClick={createBma} color="primary" type="submit" variant="contained" disabled={selectedBroker == null || isLoadingModal || isReadOnly}>
                  Create BMA
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={showAddListing} fullWidth={false} maxWidth={'lg'}>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box sx={{ marginRight: '20px' }}>
              <AdvancedSearch
                labelText={'Broker'}
                displayValueAccessorKey={'companyName'}
                saveIdValueAccessorKey={'vendorId'}
                searchingCriteria={searchingColumns}
                searchingCriteriaExtensions={searchingColumnExtensions}
                searchingRows={vendors}
                id={selectedBroker}
                value={selectedBrokerName}
                setIdValue={(id, value) => {
                  setSelectedBroker(id);
                  setSelectedBrokerName(value);
                }}
                isReadOnly={isReadOnly || useBmaBroker || isLoadingModal}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    name="useBmaBroker"
                    checked={useBmaBroker}
                    onChange={e => toggleUseBmaBroker(e.target.checked)}
                    disabled={isReadOnly || bmaBroker == null}
                  />
                }
                label="Use BMA Broker"
              />
            </Box>
            <Box>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'listingType'}>
                  Type
                </InputLabel>
                <Select
                  labelId={'listingType'}
                  key={'listingType'}
                  label={'listingType'}
                  name={'listingType'}
                  required={true}
                  disabled={isReadOnly || isFirstListing || isLoadingModal}
                  value={isFirstListing ? '9846c356-95e2-41ec-921d-338def4ef81a' : listingType}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setListingType(e.target.value)}
                >
                  {filteredListingTypes().map(opt => (
                    <MenuItem
                      key={opt.id}
                      value={opt.id}
                      sx={{ margin: 'dense' }}
                      disabled={isReadOnly || opt.title === ORIGINAL_LISTING_TYPE_TITLE}
                    >
                      {opt.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isLoadingModal && !isReadOnly && (
              <>
                <Button onClick={() => setShowAddListing(false)}>Cancel</Button>
                <Button
                  onClick={createListing}
                  color="primary"
                  type="submit"
                  variant="contained"
                  disabled={selectedBroker == null || listingType == null || isLoadingModal || isReadOnly}
                >
                  Create Listing
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={showAddEquity} fullWidth={false} maxWidth={'lg'}>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'saleType'}>
                  {' '}
                  Sale Type
                </InputLabel>
                <Select
                  labelId={'equitySaleType'}
                  key={'equitySaleType'}
                  label={'equitySaleType'}
                  name={'equitySaleType'}
                  required={true}
                  disabled={isReadOnly || isLoadingModal}
                  value={equitySaleType}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setEquitySaleType(e.target.value)}
                >
                  {typeOptions.map(opt => (
                    <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={isReadOnly}>
                      {opt.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
            <Box>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'saleType'}>
                  Equity Type
                </InputLabel>
                <Select
                  labelId={'equityStatus'}
                  key={'equityStatus'}
                  label={'equityStatus'}
                  name={'equityStatus'}
                  required={true}
                  disabled={isReadOnly || isLoadingModal}
                  value={equityStatus}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setEquityStatus(e.target.value)}
                >
                  {equityStatuses.map(opt => (
                    <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={isReadOnly}>
                      {opt.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
            <Box>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'equityRecordType'}>
                  Record Type
                </InputLabel>
                <Select
                  labelId={'equityRecordType'}
                  key={'equityRecordType'}
                  label={'equityRecordType'}
                  name={'equityRecordType'}
                  required={true}
                  disabled={isReadOnly || isLoadingModal}
                  value={equityRecordType}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setEquityRecordType(e.target.value)}
                >
                  {['P', 'S'].map(opt => (
                    <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }} disabled={isReadOnly}>
                      {opt}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isLoadingModal && !isReadOnly && (
              <>
                <Button onClick={() => setShowAddEquity(false)}>Cancel</Button>
                <Button
                  onClick={createEquity}
                  color="primary"
                  type="submit"
                  variant="contained"
                  disabled={equityStatus == null || equitySaleType == null || isLoadingModal || isReadOnly}
                >
                  Create Equity
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={showPostVoucher} fullWidth={true} maxWidth={'lg'}>
          <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px' }}>
            <Box sx={{ marginRight: '10px' }}>
              <AdvancedSearch
                labelText={'Vendor for Proceeds'}
                displayValueAccessorKey={'companyName'}
                saveIdValueAccessorKey={'vendorId'}
                searchingCriteria={[
                  { name: 'vendorId', title: 'Vendor Id' },
                  { name: 'companyName', title: 'Company Name' },
                  { name: 'city', title: 'City' },
                  { name: 'state', title: 'State' },
                  { name: 'phone', title: 'Company Phone' },
                  { name: 'email', title: 'Company Email' }
                ]}
                searchingCriteriaExtensions={[
                  { columnName: 'vendorId', width: 150 },
                  { columnName: 'companyName', width: 250 },
                  { name: 'city', width: 175 },
                  { name: 'state', width: 175 },
                  { columnName: 'phone', width: 175 },
                  { columnName: 'email', width: 175 }
                ]}
                searchingRows={vendorsPreferredVendorSorted}
                id={proceedsVendorId}
                value={proceedsVendorName}
                setIdValue={(id, value) => {
                  setProceedsVendorId(id);
                  setProceedsVendorName(value);
                }}
                isReadOnly={isReadOnly}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
            <Box sx={{ marginRight: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="createAsWireTransfer"
                    value={createAsWireTransfer}
                    onChange={e => setCreateAsWireTransfer(!createAsWireTransfer)}
                    disabled={isReadOnly}
                  />
                }
                label="Create as a Wire Transfer"
              />
            </Box>
            <Box sx={{ marginRight: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="createAsRushPayment"
                    value={createAsRushPayment}
                    onChange={e => setCreateAsRushPayment(!createAsRushPayment)}
                    disabled={isReadOnly}
                  />
                }
                label="Create as a Rush Payment"
              />
            </Box>
            <Box sx={{ marginRight: '10px' }}>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'saleType'}>
                  {' '}
                  Batch Type
                </InputLabel>
                <Select
                  name={'batchType'}
                  required={true}
                  disabled={isReadOnly}
                  value={batchType}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setBatchType(e.target.value)}
                >
                  <MenuItem disabled={isReadOnly} value={'ACH/WIRE'} sx={{ margin: 'dense' }}>
                    ACH/WIRE
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'AP TRACKING'} sx={{ margin: 'dense' }}>
                    AP TRACKING
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'BILL TO EE - CHECK'} sx={{ margin: 'dense' }}>
                    BILL TO EE - CHECK
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'BILL TO EE - INTL'} sx={{ margin: 'dense' }}>
                    BILL TO EE - INTL
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'BILL TO EE - ACH/WIRE'} sx={{ margin: 'dense' }}>
                    BILL TO EE - ACH/WIRE
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'BILL TO EE - TRACKING'} sx={{ margin: 'dense' }}>
                    BILL TO EE - TRACKING
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'BLACKOUT'} sx={{ margin: 'dense' }}>
                    BLACKOUT
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'CHECK'} sx={{ margin: 'dense' }}>
                    CHECK
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'CLIENT INTEREST'} sx={{ margin: 'dense' }}>
                    CLIENT INTEREST
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'CODING CORRECTION'} sx={{ margin: 'dense' }}>
                    CODING CORRECTION
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'DEPOSIT'} sx={{ margin: 'dense' }}>
                    DEPOSIT
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'EM TRACKING'} sx={{ margin: 'dense' }}>
                    EM TRACKING
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'FEE'} sx={{ margin: 'dense' }}>
                    FEE
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'INTERNATIONAL'} sx={{ margin: 'dense' }}>
                    INTERNATIONAL
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'JOUNRAL ENTRY'} sx={{ margin: 'dense' }}>
                    JOUNRAL ENTRY
                  </MenuItem>
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
            <Box>
              <FormControl sx={{ marginTop: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'saleType'}>
                  Not Payable
                </InputLabel>
                <Select
                  name={'notPayable'}
                  required={true}
                  disabled={isReadOnly}
                  value={notPayabale}
                  margin="dense"
                  variant="standard"
                  sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setNotPayable(e.target.value)}
                >
                  <MenuItem disabled={isReadOnly} value={'N/A'} sx={{ margin: 'dense' }}>
                    N/A
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'Backout / Re-Enter'} sx={{ margin: 'dense' }}>
                    Backout / Re-Enter
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'Cost Avoidance'} sx={{ margin: 'dense' }}>
                    Cost Avoidance
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'Paid by Client Through Payroll'} sx={{ margin: 'dense' }}>
                    Paid by Client Through Payroll
                  </MenuItem>
                  <MenuItem disabled={isReadOnly} value={'Tracking'} sx={{ margin: 'dense' }}>
                    Tracking
                  </MenuItem>
                </Select>
              </FormControl>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          </Box>
          <DialogActions sx={{ p: '1.25rem' }}>
            {isLoadingModal && <Spinner />}
            {!isLoadingModal && !isReadOnly && (
              <>
                <Button onClick={() => setShowPostVoucher(false)}>Cancel</Button>
                <Button
                  onClick={postVoucher}
                  color="primary"
                  type="submit"
                  variant="contained"
                  disabled={batchType == null || notPayabale == null || proceedsVendorId == null || isLoadingModal || isReadOnly}
                >
                  Post
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
      </Box>
      {showTriggeredComment && (
        <ServiceTriggeredComment
          authorizationId={id}
          serviceOptionId={'f81b6b37-52b0-4903-9203-6fd184192054'}
          displayText={'Homesale - Service Completed Comment'}
          setShowTriggeredComment={setShowTriggeredComment}
          enumerations={enumerations}
        />
      )}
      {showComment && (
        <SlidingCommentsAndNotes
          authorizationId={id}
          serviceOptionId={'f81b6b37-52b0-4903-9203-6fd184192054'}
          setShowComment={setShowComment}
          isOpen={true}
          enumerations={enumerations}
        />
      )}
    </>
  );
};

HomesaleService.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { homesaleStatusTypes } = state.enumerations.allEnums;
  return {
    shouldShowSideDrawer: state.layout.shouldShowSideDrawer,
    homesaleStatusTypes: homesaleStatusTypes
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    showToast,
    postAppraisal,
    getAllAppraisals,
    postHomesaleInfo,
    updateHomesaleInfo,
    postListing,
    getAllListings,
    postEquity,
    updateEquity,
    deleteEquity,
    getSpreadSelection,
    getBuyout,
    resetHomesaleStatus,
    getHomesaleInfo,
    getServiceStatusDates
  })
)(HomesaleService);
